exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".CreateCase .esign-title{font-size:16px;letter-spacing:0px;color:rgba(0,0,0,.8705882353);opacity:1}.CreateCase .esign-info{font-size:16px;font-weight:700;color:rgba(0,0,0,.8705882353);opacity:1}.CreateCase .errorMessageCustom{color:#f44336;font-size:.9rem;text-align:left;font-family:\"Assistant\",\"Helvetica\",\"Arial\",sans-serif;font-weight:400;line-height:1.66;margin-bottom:5px}.attestation{margin-top:-7px !important}.setCheckBox{align-items:start !important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Product/CreateCase/CreateCase.scss
// module id = 1810
// module chunks = 101